module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-richard-1.155c6bce.jpg";